export const FETCH_ONBOARDING_SETTINGS = 'FETCH_ONBOARDING_SETTINGS';
export const FETCH_ONBOARDING_SETTINGS_SUCCESS = 'FETCH_ONBOARDING_SETTINGS_SUCCESS';
export const FETCH_ONBOARDING_SETTINGS_FAILED = 'FETCH_ONBOARDING_SETTINGS_FAILED';

export const SAVE_ONBOARDING_SETTINGS = 'SAVE_ONBOARDING_SETTINGS';
export const SAVE_ONBOARDING_SETTINGS_SUCCESS = 'SAVE_ONBOARDING_SETTINGS_SUCCESS';
export const SAVE_ONBOARDING_SETTINGS_FAILED = 'SAVE_ONBOARDING_SETTINGS_FAILED';

export const SHOW_LOADING_INDICATOR = 'SHOW_LOADING_INDICATOR';
export const HIDE_LOADING_INDICATOR = 'HIDE_LOADING_INDICATOR';

export const SHOW_CONFIRMATION = 'SHOW_CONFIRMATION';
export const HIDE_CONFIRMATION = 'HIDE_CONFIRMATION'